import { initialState } from './state';

export function set(state, enabledModules) {
    Object.assign(state.modules, enabledModules);
}